import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
  },
  gridItem: {
    display: 'flex',
  },
  statusButton: {
    padding: 10,
    borderColor: theme.palette.custom.border,
    backgroundColor: theme.palette.common.white,
    boxShadow: 'none',
  },
  containerButton: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    alignItems: 'center',
    width: '100%',
  },
  containerIcon: {
    color: theme.palette.common.white,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    width: 20,
    height: 20,
  },
  statusIcon: {
    padding: 4,
  },
}))

export default styles
